import { createSelector } from '@reduxjs/toolkit';
import { ascend, prop, sortWith } from 'ramda';

const categorySort = sortWith([ascend(prop('type')), ascend(prop('categoryName'))]);
export const getCategoriesState = (state) => state.categories;

export const getCategoryState = (state) => state.category;

export const getCategories = createSelector(
  getCategoriesState,
  (categoriesState) => categoriesState.data && categorySort(categoriesState.data),
);

export const getCategoriesObj = createSelector(getCategoriesState, (categories) => {
  if (!categories.data) return null;
  return categories.data.reduce((acc, category) => {
    const { categoryId, categoryName, type } = category;
    return { [categoryId]: { categoryId, categoryName, type }, ...acc };
  }, {});
});
